import { render, staticRenderFns } from "./candidateJobDetail.vue?vue&type=template&id=4080d52a&scoped=true&"
import script from "./candidateJobDetail.vue?vue&type=script&lang=js&"
export * from "./candidateJobDetail.vue?vue&type=script&lang=js&"
import style0 from "./candidateJobDetail.vue?vue&type=style&index=0&id=4080d52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080d52a",
  null
  
)

export default component.exports